import {
	faChevronUp,
	faChevronDown,
	faChevronCircleUp,
	faChevronCircleDown
} from "@fortawesome/free-solid-svg-icons";
import React, { useContext } from "react";
import { AccordionContext, Accordion } from "react-bootstrap";

import FASvgIcon from "../FASvgIcon";

type Props = { children: JSX.Element; eventKey: string; isChild?: boolean };

const ContextAwareToggle: React.FC<Props> = (props: Props) => {
	const { children, eventKey, isChild = false } = props;
	const { activeEventKey } = useContext(AccordionContext);

	const isCurrentEventKey = activeEventKey === eventKey;

	const openIcon = isChild ? faChevronCircleUp : faChevronUp;
	const closeIcon = isChild ? faChevronCircleDown : faChevronDown;

	return (
		<Accordion.Header>
			{children}
			<FASvgIcon icon={isCurrentEventKey ? openIcon : closeIcon} />
		</Accordion.Header>
	);
};

export default ContextAwareToggle;
